export default __webpack_public_path__ + "static/media/coin_dsh.e448be5e.svg";